import { SVGProps } from "react"

const ArrowDown2Icon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 9L12.7809 14.3306C12.3316 14.7158 11.6684 14.7158 11.2191 14.3306L5 9"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default ArrowDown2Icon
